var $dd84a0b574be3f23$exports = {};
$dd84a0b574be3f23$exports = {
  "removeButtonLabel": "No\u0146emt",
  "removeDescription": "Nospiediet Delete [Dz\u0113st], lai no\u0146emtu tagu."
};
export { $dd84a0b574be3f23$exports as default };